export const sequence_detail_settings_en = {
  sequence_detail_settings_name_name: "Sequence name",
  sequence_detail_settings_name_desc:
    "Give your sequence a clear, recognizable name to help you and your team stay organized.",
  sequence_detail_settings_label_name: "Label",
  sequence_detail_settings_label_desc:
    "Add a label to group or categorize your sequences — like by campaign, region, product, or sales stage.",
  sequence_detail_settings_schedule_name: "Schedule",
  sequence_detail_settings_schedule_desc:
    "Set when this sequence is active — choose the days and time range your messages will be sent.",
  sequence_schedule_main_empty_title: "Nothing here",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "Create a schedule",
  timezone: "Timezone: ",
  sequence_schedule_time_zone:
    "Use the contact's local time zone instead of the schedule's time zone, if the contact contains location data.",
  sequence_schedule_holidays:
    "Skip the following national holidays: Labor Day, Independence Day, Memorial Day, Thanksgiving, Christmas Eve, Christmas, New Year's Day",
  from: "From",
  to: "To",
  sequence_schedule_week_short_monday: "Mon",
  monday: "Monday",
  sequence_schedule_week_short_tuesday: "Tue",
  tuesday: "Tuesday",
  sequence_schedule_week_short_wednesday: "Wed",
  wednesday: "Wednesday",
  sequence_schedule_week_short_thursday: "Thu",
  thursday: "Thursday",
  sequence_schedule_week_short_friday: "Fri",
  friday: "Friday",
  sequence_schedule_week_short_saturday: "Sat",
  saturday: "Saturday",
  sequence_schedule_week_short_sunday: "Sun",
  sunday: "Sunday",
  sequence_schedule_aside_empty_description: "Create a schedule",
  sequence_schedule_delete_dialog_name: "Delete schedule",
  sequence_schedule_delete_sequence_dialog_select_label:
    "Select one schedule to replace the deleted one",
  sequence_schedule_delete_sequence_dialog_select_placeholder:
    "Please select ...",
  sequence_scedule_create_dialog_name: "Create schedule",
  sequence_schedule_create_sequence_dialog_input_label: "Schedule name",
  sequence_schedule_create_sequence_dialog_input_placeholder:
    "Enter schedule name",
  sequence_schedule_aside_create_new: "create a schedule",
  name: "Name",
};

export const sequence_detail_settings_zhHans = {
  sequence_detail_settings_name_name: "序列名称",
  sequence_detail_settings_name_desc:
    "为您的序列起一个清晰易识别的名称，以帮助您和您的团队保持有序。",
  sequence_detail_settings_label_name: "标签",
  sequence_detail_settings_label_desc:
    "添加标签以对您的序列进行分组或分类，例如按活动、地区、产品或销售阶段。",
  sequence_detail_settings_schedule_name: "时间表",
  sequence_detail_settings_schedule_desc:
    "设置此序列的启用时间 — 选择消息发送的日期和时间范围。",
  sequence_schedule_main_empty_title: "暂无内容",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "创建时间表",
  timezone: "时区：",
  sequence_schedule_time_zone:
    "如果联系人包含位置信息，将使用联系人的本地时区替代时间表设置的时区。",
  sequence_schedule_holidays:
    "跳过以下节假日：劳动节、独立日、阵亡将士纪念日、感恩节、平安夜、圣诞节、新年",
  from: "从",
  to: "到",
  sequence_schedule_week_short_monday: "周一",
  monday: "星期一",
  sequence_schedule_week_short_tuesday: "周二",
  tuesday: "星期二",
  sequence_schedule_week_short_wednesday: "周三",
  wednesday: "星期三",
  sequence_schedule_week_short_thursday: "周四",
  thursday: "星期四",
  sequence_schedule_week_short_friday: "周五",
  friday: "星期五",
  sequence_schedule_week_short_saturday: "周六",
  saturday: "星期六",
  sequence_schedule_week_short_sunday: "周日",
  sunday: "星期日",
  sequence_schedule_aside_empty_description: "创建一个时间表",
  sequence_schedule_delete_dialog_name: "删除时间表",
  sequence_schedule_delete_sequence_dialog_select_label:
    "选择一个时间表替代被删除的时间表",
  sequence_schedule_delete_sequence_dialog_select_placeholder: "请选择...",
  sequence_scedule_create_dialog_name: "创建时间表",
  sequence_schedule_create_sequence_dialog_input_label: "时间表名称",
  sequence_schedule_create_sequence_dialog_input_placeholder: "输入时间表名称",
  sequence_schedule_aside_create_new: "创建时间表",
  name: "名称",
};

export const sequence_detail_settings_zhHant = {
  sequence_detail_settings_name_name: "序列名稱",
  sequence_detail_settings_name_desc:
    "為您的序列命名一個清晰且易於辨識的名稱，以幫助您和團隊保持組織有序。",
  sequence_detail_settings_label_name: "標籤",
  sequence_detail_settings_label_desc:
    "新增標籤以分組或分類您的序列，例如依據活動、地區、產品或銷售階段。",
  sequence_detail_settings_schedule_name: "排程",
  sequence_detail_settings_schedule_desc:
    "設定此序列的啟用時間 — 選擇訊息傳送的日期與時間範圍。",
  sequence_schedule_main_empty_title: "尚無內容",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "建立排程",
  timezone: "時區：",
  sequence_schedule_time_zone:
    "若聯絡人包含位置信息，將使用聯絡人的本地時區，而非排程的時區。",
  sequence_schedule_holidays:
    "跳過以下國定假日：勞動節、獨立紀念日、陣亡將士紀念日、感恩節、平安夜、聖誕節、新年",
  from: "從",
  to: "到",
  sequence_schedule_week_short_monday: "週一",
  monday: "星期一",
  sequence_schedule_week_short_tuesday: "週二",
  tuesday: "星期二",
  sequence_schedule_week_short_wednesday: "週三",
  wednesday: "星期三",
  sequence_schedule_week_short_thursday: "週四",
  thursday: "星期四",
  sequence_schedule_week_short_friday: "週五",
  friday: "星期五",
  sequence_schedule_week_short_saturday: "週六",
  saturday: "星期六",
  sequence_schedule_week_short_sunday: "週日",
  sunday: "星期日",
  sequence_schedule_aside_empty_description: "建立排程",
  sequence_schedule_delete_dialog_name: "刪除排程",
  sequence_schedule_delete_sequence_dialog_select_label:
    "選擇一個排程以取代已刪除的排程",
  sequence_schedule_delete_sequence_dialog_select_placeholder: "請選擇...",
  sequence_scedule_create_dialog_name: "建立排程",
  sequence_schedule_create_sequence_dialog_input_label: "排程名稱",
  sequence_schedule_create_sequence_dialog_input_placeholder: "輸入排程名稱",
  sequence_schedule_aside_create_new: "建立排程",
  name: "名稱",
};

export const sequence_detail_settings_japanese = {
  sequence_detail_settings_name_name: "シーケンス名",
  sequence_detail_settings_name_desc:
    "チームと組織を整理するために、明確で認識しやすい名前をシーケンスに付けます。",
  sequence_detail_settings_label_name: "ラベル",
  sequence_detail_settings_label_desc:
    "活動、地域、製品、または販売段階などでシーケンスをグループ化または分類するためにラベルを追加します。",
  sequence_detail_settings_schedule_name: "スケジュール",
  sequence_detail_settings_schedule_desc:
    "このシーケンスのアクティブ時間を設定します — メッセージ送信の日付と時間範囲を選択します。",
  sequence_schedule_main_empty_title: "コンテンツがありません",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "スケジュールを作成",
  timezone: "タイムゾーン：",
  sequence_schedule_time_zone:
    "連絡先に位置情報が含まれている場合、スケジュールのタイムゾーンではなく連絡先の現地タイムゾーンが使用されます。",
  sequence_schedule_holidays:
    "次の祝日をスキップします：労働節、独立記念日、戦没者追悼記念日、感謝祭、クリスマスイブ、クリスマス、新年",
  from: "から",
  to: "まで",
  sequence_schedule_week_short_monday: "月",
  monday: "月曜日",
  sequence_schedule_week_short_tuesday: "火",
  tuesday: "火曜日",
  sequence_schedule_week_short_wednesday: "水",
  wednesday: "水曜日",
  sequence_schedule_week_short_thursday: "木",
  thursday: "木曜日",
  sequence_schedule_week_short_friday: "金",
  friday: "金曜日",
  sequence_schedule_week_short_saturday: "土",
  saturday: "土曜日",
  sequence_schedule_week_short_sunday: "日",
  sunday: "日曜日",
  sequence_schedule_aside_empty_description: "スケジュールを作成",
  sequence_schedule_delete_dialog_name: "スケジュールを削除",
  sequence_schedule_delete_sequence_dialog_select_label:
    "削除されたスケジュールを置き換えるスケジュールを選択してください",
  sequence_schedule_delete_sequence_dialog_select_placeholder: "選択してください...",
  sequence_scedule_create_dialog_name: "スケジュールを作成",
  sequence_schedule_create_sequence_dialog_input_label: "スケジュール名",
  sequence_schedule_create_sequence_dialog_input_placeholder: "スケジュール名を入力",
  sequence_schedule_aside_create_new: "スケジュールを作成",
  name: "名前"
};

export const sequence_detail_settings_korean = {
  sequence_detail_settings_name_name: "시퀀스 이름",
  sequence_detail_settings_name_desc:
    "팀과 조직을 체계적으로 유지하기 위해 명확하고 식별하기 쉬운 이름을 시퀀스에 지정하세요.",
  sequence_detail_settings_label_name: "라벨",
  sequence_detail_settings_label_desc:
    "활동, 지역, 제품 또는 판매 단계 등으로 시퀀스를 그룹화하거나 분류하기 위해 라벨을 추가하세요.",
  sequence_detail_settings_schedule_name: "일정",
  sequence_detail_settings_schedule_desc:
    "이 시퀀스의 활성 시간을 설정하세요 — 메시지 전송 날짜와 시간 범위를 선택하세요.",
  sequence_schedule_main_empty_title: "내용 없음",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "일정 생성",
  timezone: "시간대:",
  sequence_schedule_time_zone:
    "연락처에 위치 정보가 포함된 경우, 일정의 시간대가 아닌 연락처의 현지 시간대가 사용됩니다.",
  sequence_schedule_holidays:
    "다음 공휴일은 건너뜁니다: 노동절, 독립기념일, 현충일, 추수감사절, 크리스마스 이브, 크리스마스, 새해",
  from: "부터",
  to: "까지",
  sequence_schedule_week_short_monday: "월",
  monday: "월요일",
  sequence_schedule_week_short_tuesday: "화",
  tuesday: "화요일",
  sequence_schedule_week_short_wednesday: "수",
  wednesday: "수요일",
  sequence_schedule_week_short_thursday: "목",
  thursday: "목요일",
  sequence_schedule_week_short_friday: "금",
  friday: "금요일",
  sequence_schedule_week_short_saturday: "토",
  saturday: "토요일",
  sequence_schedule_week_short_sunday: "일",
  sunday: "일요일",
  sequence_schedule_aside_empty_description: "일정 생성",
  sequence_schedule_delete_dialog_name: "일정 삭제",
  sequence_schedule_delete_sequence_dialog_select_label:
    "삭제된 일정을 대체할 일정을 선택하세요",
  sequence_schedule_delete_sequence_dialog_select_placeholder: "선택하세요...",
  sequence_scedule_create_dialog_name: "일정 생성",
  sequence_schedule_create_sequence_dialog_input_label: "일정 이름",
  sequence_schedule_create_sequence_dialog_input_placeholder: "일정 이름 입력",
  sequence_schedule_aside_create_new: "일정 생성",
  name: "이름"
};

export const sequence_detail_settings_hindi = {
  sequence_detail_settings_name_name: "अनुक्रम नाम",
  sequence_detail_settings_name_desc:
    "अपने और टीम को संगठित रखने में मदद के लिए अपने अनुक्रम को एक स्पष्ट और पहचानने योग्य नाम दें।",
  sequence_detail_settings_label_name: "लेबल",
  sequence_detail_settings_label_desc:
    "अपने अनुक्रम को समूहबद्ध या वर्गीकृत करने के लिए लेबल जोड़ें, जैसे गतिविधि, क्षेत्र, उत्पाद या बिक्री चरण के आधार पर।",
  sequence_detail_settings_schedule_name: "अनुसूची",
  sequence_detail_settings_schedule_desc:
    "इस अनुक्रम के सक्रिय समय को सेट करें — संदेश भेजने के लिए तिथि और समय सीमा चुनें।",
  sequence_schedule_main_empty_title: "कोई सामग्री नहीं",
  sequence_schedule_main_empty_description: "",
  sequence_schedule_main_empty_button: "अनुसूची बनाएं",
  timezone: "समय क्षेत्र:",
  sequence_schedule_time_zone:
    "यदि संपर्क में स्थान जानकारी शामिल है, तो अनुसूची के समय क्षेत्र के बजाय संपर्क का स्थानीय समय क्षेत्र उपयोग किया जाएगा।",
  sequence_schedule_holidays:
    "निम्नलिखित सार्वजनिक अवकाश छोड़ें: श्रम दिवस, स्वतंत्रता दिवस, स्मरण दिवस, धन्यवाद दिवस, क्रिसमस की पूर्व संध्या, क्रिसमस, नया साल",
  from: "से",
  to: "तक",
  sequence_schedule_week_short_monday: "सोम",
  monday: "सोमवार",
  sequence_schedule_week_short_tuesday: "मंगल",
  tuesday: "मंगलवार",
  sequence_schedule_week_short_wednesday: "बुध",
  wednesday: "बुधवार",
  sequence_schedule_week_short_thursday: "गुरु",
  thursday: "गुरुवार",
  sequence_schedule_week_short_friday: "शुक्र",
  friday: "शुक्रवार",
  sequence_schedule_week_short_saturday: "शनि",
  saturday: "शनिवार",
  sequence_schedule_week_short_sunday: "रवि",
  sunday: "रविवार",
  sequence_schedule_aside_empty_description: "अनुसूची बनाएं",
  sequence_schedule_delete_dialog_name: "अनुसूची हटाएं",
  sequence_schedule_delete_sequence_dialog_select_label:
    "हटाई गई अनुसूची को प्रतिस्थापित करने के लिए एक अनुसूची चुनें",
  sequence_schedule_delete_sequence_dialog_select_placeholder: "चुनें...",
  sequence_scedule_create_dialog_name: "अनुसूची बनाएं",
  sequence_schedule_create_sequence_dialog_input_label: "अनुसूची नाम",
  sequence_schedule_create_sequence_dialog_input_placeholder: "अनुसूची नाम दर्ज करें",
  sequence_schedule_aside_create_new: "अनुसूची बनाएं",
  name: "नाम"
};